import { render, staticRenderFns } from "./QuestionMarkIcon.vue?vue&type=template&id=212535c0&scoped=true&"
import script from "./QuestionMarkIcon.vue?vue&type=script&lang=ts&"
export * from "./QuestionMarkIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212535c0",
  null
  
)

export default component.exports